import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/homePage/index.vue";
import contact from "../views/contactPage/index.vue";
import about from "../views/aboutPage/index.vue";
import articles from "../views/articlesPage/index.vue";
import articleDetailePage from "../views/articleDetailePage/index.vue";
import cartPage from "../views/cartPage/index.vue";
import wishlist from "../views/wishlistPage/index.vue";
import wishlistFriend from "../views/wishlistFriendPage/index.vue";
import loginAndRegister from "../views/loginAndRegister/index.vue";
import profilePage from "../views/profilePage/index.vue";
import navbar from "../views/navbar/index.vue";
import slideProfilePage from "../views/slideProfilePage/index.vue";
import articlesProfile from "../views/articlesProfile/index.vue";
import recentlyViewed from "../views/recentlyViewed/index.vue";
import userInformation from "../views/userInformation/index.vue";
import userPassword from "../views/userPassword/index.vue";
import userAdress from "../views/userAdress/index.vue";
import conditionsPage from "../views/conditionsPage/index.vue";
import confidentialitePage from "../views/confidentialitePage/index.vue";
import howToUsePage from "../views/howToUsePage/index.vue";
import articlesByFiltrePage from "../views/articlesByFiltrePage/index.vue";
import articlesSearchPage from "../views/articlesSearchPage/index.vue";



Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    redirect: "Home",
    component: navbar,
    children: [
      {
        path: "/Home",
        name: "Home",
        component: Home,
      },
      {
        path: "/conditions",
        name: "Conditions‌ ‌Générales‌ ‌d’utilisation‌",
        component: conditionsPage,
      },
      {
        path: "/confidentialite",
        name: "Politique de Confidentialité",
        component: confidentialitePage,
      },
      {
        path: "/howToUse",
        name: "Comment ça marche",
        component: howToUsePage,
      },

      {
        path: "/contact",
        name: "Contact",
        component: contact,
      },
      {
        path: "/about",
        name: "A propos",
        component: about,
      },
      {
        path: "/articles",
        name: "Nos articles",
        component: articles,
      },
      {
        path: "/articles-search",
        name: "Nos articles",
        component: articlesSearchPage,
      },    
      {
        path: "/detail-article",
        name: "Detail article",
        component: articleDetailePage,
      },
      {
        path: "/cart",
        name: "Panier",
        component: cartPage,
      },
      {
        path: "/articles-Filtre",
        name: "Articles",
        component: articlesByFiltrePage,
      },
      {
        path: "/wishlist",
        name: "Wish-list",
        component: wishlist,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("Giftstore-U")) {
            next();
          } else {
            Vue.$toast.open({
              message: "Vous devez être connecter",
              type: "info",
              // position: "top-right",
              // all of other options may go here
            });
            from();
          }
        },
      },
      {
        path: "/wishlist-friend",
        name: "Wish-list",
        component: wishlistFriend,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("Giftstore-U")) {
            next();
          } else {
            Vue.$toast.open({
              message: "Vous devez être connecter",
              type: "info",
              // position: "top-right",
              // all of other options may go here
            });
            from();
          }
        },
      },
      {
        path: "/profile",
        redirect: "Profil",
        component: slideProfilePage,
        children: [
          {
            path: "/profile",
            name: "Profil",
            component: profilePage,
          },
          {
            path: "/profileCommande",
            name: "Profil",
            component: articlesProfile,
          },
          {
            path: "/profileViewedArticles",
            name: "Profil",
            component: recentlyViewed,
          },
          {
            path: "/profileInformation",
            name: "Profil",
            component: userInformation,
          },
          {
            path: "/profilePassword",
            name: "Profil",
            component: userPassword,
          },
          {
            path: "/profileAdress",
            name: "Profil",
            component: userAdress,
          },
        ],
      },
    ],
  },
  {
    path: "/loginAndRegister",
    name: "loginandregister",
    component: loginAndRegister,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem("Giftstore-U")) {
        next();
      } else {
        Vue.$toast.open({
          message: "vous êtes déjà connecté",
          type: "info",
          // position: "top-right",
          // all of other options may go here
        });
        from();
      }
    },
  },

  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
